export const eventTypes = {
  linkClicked: 'linkClicked',
  newNote: 'newNote',
  toggleHide: 'toggleHide',
}
